import { render, staticRenderFns } from "./detail7.vue?vue&type=template&id=160aeac2&scoped=true"
import script from "./detail7.vue?vue&type=script&lang=js"
export * from "./detail7.vue?vue&type=script&lang=js"
import style0 from "./detail7.vue?vue&type=style&index=0&id=160aeac2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160aeac2",
  null
  
)

export default component.exports